import React from "react"
import { useTranslation } from "react-i18next"

import { Content } from "pages/dashboard/elements"
import Title from "components/ui/Title"
import Invoices from "components/DebtPayments/Invoices"

const PaymentsPage = () => {
  const { t } = useTranslation()

  return (
    <Content data-testid="claim-payments-page">
      <Title>{t("pages.payments.title")}</Title>
      <Invoices />
    </Content>
  )
}

export default PaymentsPage
